var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.835 1.859a1.089 1.089 0 111.54-1.54l5.806 5.806a1.089 1.089 0 010 1.54l-5.806 5.806a1.089 1.089 0 01-1.54-1.54l5.037-5.036-5.037-5.036z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.089 5.806H21.41a1.089 1.089 0 010 2.178H1.09a1.089 1.089 0 110-2.178z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.304b2de2.svg";
export { ForwardRef as ReactComponent };